import React, { useState } from "react";
import Button from "./Button";
import Expandable from "./Expandable";
import Flex from "./Flex";
import Typo from "./Typo";

const List = React.forwardRef(({
  className,
  segmented,
  level,
  padding,
  id,
  style,
  children,
  ...rest
}, ref) => {
  const classes = [
    "ta-list",
    className,
    padding && "ta-padding_" + padding,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} id={id} className={classes} style={style} data-segmented={segmented ? "true" : undefined} data-level={level || undefined} {...rest}>
      {children}
    </div>
  );
});

export const ListItem = React.forwardRef(({
  className,
  selected,
  onClick,
  id,
  style,
  leading,
  label,
  supporting,
  children,
  trailing,
  expandable,
  ...rest
}, ref) => {
  const [isExpanded, setExpanded] = useState(false);

  const classes = [
    "ta-list_item",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <div
        ref={ref}
        onClick={() => onClick && onClick()}
        id={id}
        className={classes}
        style={style}
        data-selected={selected ? "true" : undefined}
        {...rest}
      >
        {leading && leading}
        <Flex vertical className="ta-is-overflow ta-flexitem">
          {label && (
            <Typo noWrap className="ta-flexitem ta-color-text_on-surface">
              {label}
            </Typo>
          )}
          {supporting && (
            <Typo
              noWrap
              type="label"
              size="l"
              className="ta-flexitem ta-color-text_on-surface-variant"
            >
              {supporting}
            </Typo>
          )}
          {children && children}
        </Flex>
        {trailing && trailing}

        {expandable && (
          <Button
            onClick={() => expandable && setExpanded(!isExpanded)}
            symbol={isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            icon
          />
        )}
      </div>
      {expandable && (
        <Expandable animate={isExpanded}>{expandable}</Expandable>
      )}
    </>
  );
});

export default List;
